import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Link, Type } from '@nerdwallet/currency';

const CompanyMatrixTile = ({
  title,
  titleSize,
  description,
  value,
  subheader,
  subheaderLink,
  boardDescription,
  boardBackground,
  columnClass,
}) => (
  <div className={columnClass}>
    {title && (
      <Type
        size={titleSize}
        chronicle
        className={classNames(['matrix__header'])}
      >
        {title}
      </Type>
    )}
    {description && (
      <Type gotham size="1" className={classNames(['matrix__description'])}>
        {description}
      </Type>
    )}
    {value && (
      <Type
        gotham
        className={classNames([
          'matrix__description',
          classes('text-small'),
          classes('text-default--wide'),
          classes('margin-top-3'),
        ])}
      >
        {value}
      </Type>
    )}
    {subheader && !subheaderLink && (
      <Type gotham size="1">
        {subheader}
      </Type>
    )}
    {subheader && subheaderLink && title && (
      <Link href={subheaderLink} key={title}>
        <Type gotham size="1">
          {subheader}
        </Type>
      </Link>
    )}
    {boardDescription && (
      <Type gotham size="1" className={classNames([classes('margin-top-3')])}>
        {boardDescription}
      </Type>
    )}
    {boardBackground && (
      <Type gotham size="1" className={classNames([classes('margin-top-3')])}>
        {boardBackground}
      </Type>
    )}
  </div>
);

CompanyMatrixTile.propTypes = {
  title: PropTypes.string,
  titleSize: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  subheader: PropTypes.string,
  subheaderLink: PropTypes.string,
  boardDescription: PropTypes.string,
  boardBackground: PropTypes.string,
  columnClass: PropTypes.string,
};

CompanyMatrixTile.displayName = 'Company Matrix Tile';

export default CompanyMatrixTile;
